"use client";
import {
  useComboboxContext
} from "../__chunks/DWZ7E5TJ.js";
import "../__chunks/WENSINUV.js";
import "../__chunks/FMYQNSCK.js";
import "../__chunks/54MGSIOI.js";
import "../__chunks/DU4D3UCJ.js";
import "../__chunks/RGUP62TM.js";
import "../__chunks/HKOOKEDE.js";
import "../__chunks/Z32BISHQ.js";
import "../__chunks/SK3NAZA3.js";
import "../__chunks/3YLGPPWQ.js";

// src/combobox/combobox-value.tsx
import { invariant } from "@ariakit/core/utils/misc";
function ComboboxValue({ store, children } = {}) {
  const context = useComboboxContext();
  store = store || context;
  invariant(
    store,
    process.env.NODE_ENV !== "production" && "ComboboxValue must receive a `store` prop or be wrapped in a ComboboxProvider component."
  );
  const value = store.useState("value");
  if (children) {
    return children(value);
  }
  return value;
}
export {
  ComboboxValue
};
